import { i18n } from '/business/shared/translations/i18n';

import { questionBuilder } from '/business/shared/components/questions/helper/questionBuilder';
import { getConfigureRefrigerants } from '/business/shared/components/questions/scope1/_config/getConfigureRefrigerants';
import { getQuestionBuildingOtherFuels } from '/business/shared/components/questions/scope1/_config/getConfigureOtherFuels';
import { getConfigureEmployeeCommutes } from '/business/shared/components/questions/scope3/employeeCommutes/_config/getConfigureEmployeeCommutes';
import { getConfigureCompanyVehicles } from '/business/shared/components/questions/scope1/companyVeh/_config/getConfigureCompanyVehicles';
import { getConfigureFireFightingExercises } from '/business/shared/components/questions/scope1/_config/getConfigureFireFightingExercises';
import { getConfigureBoilersAndFurnaces } from '/business/shared/components/questions/scope1/_config/getConfigureBoilersAndFurnaces';
import { getConfigureEvCharging } from '/business/shared/components/questions/scope2/_config/getConfigureEvCharging';
import { getConfigureOnSitePowerGeneration } from '/business/shared/components/questions/scope1/_config/getConfigureOnSitePowerGeneration';
import { getConfigureOnSiteWaterTreatment } from '/business/shared/components/questions/scope1/_config/getConfigureOnSiteWaterTreatment';

import vehicleIcons from '/shared/util/vehicleIcons';
import { reductionCardsSlides } from '/business/airbp/reducePage';
import { getConfigureDeicing } from '/business/shared/components/questions/scope1/_config/getConfigureDeicing';
import { getConfigureWasteGeneratedInOps } from '/business/shared/components/questions/scope3/_config/getConfigureWasteGeneratedInOps';
import { getConfigurePhantomFuelAndEnergy } from '/business/shared/components/questions/scope3/_config/getConfigurePhantomFuelAndEnergy';
import { getQuestionBusinessTravel } from '/business/shared/components/questions/scope3/businessTravel/_config/getConfigureBusinessTravelSection';
import { getConfigureElectricityHeatSteam } from '/business/shared/components/questions/scope2/_config/getConfigureElectricityHeatSteam';

export const getQuestionsLookup = () => {
  const isScopeBased = true;

  const buildingRefrigerants = getConfigureRefrigerants({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
    reductionCardsSlides: reductionCardsSlides.refrigerants,
  });
  const buildingOtherFuels = getQuestionBuildingOtherFuels({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
  });
  const travelVehicles = getConfigureCompanyVehicles({
    i18n,
    provideTotalFuelPage: true,
    provideVehicleBreakdownPage: false,
    hasScopeBasedOrganisation: isScopeBased,
    reductionCardsSlides: reductionCardsSlides.companyVehicles,
  });
  const travelEmployeeCommutes = getConfigureEmployeeCommutes({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
    vehicleIcon: vehicleIcons.commutesCar,
    reductionCardsSlides: reductionCardsSlides.employeeCommutes,
  });
  const firefightingExercises = getConfigureFireFightingExercises({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
    reductionCardsSlides: reductionCardsSlides.fireFightingExercises,
  });
  const boilersAndFurnaces = getConfigureBoilersAndFurnaces({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
    reductionCardsSlides: reductionCardsSlides.boilersAndFurnances,
  });
  const onSitePowerGeneration = getConfigureOnSitePowerGeneration({
    i18n,
    reductionCardsSlides: reductionCardsSlides.onSitePowerGeneration,
  });
  const onSiteWaterTreatment = getConfigureOnSiteWaterTreatment({
    i18n,
    reductionCardsSlides: reductionCardsSlides.companyVehicles,
  });
  const evCharging = getConfigureEvCharging({
    i18n,
    reductionCardsSlides: reductionCardsSlides.evCharging,
  });
  const wasteGeneratedInOps = getConfigureWasteGeneratedInOps({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
  });
  const phantomFuelAndEnergy = getConfigurePhantomFuelAndEnergy({
    i18n,
  });
  const businessTravel = getQuestionBusinessTravel({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
    reductionCardsSlides: reductionCardsSlides.businessTravel,
  });
  const deicing = getConfigureDeicing({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
    reductionCardsSlides: [],
  });
  const electricityHeatSteam = getConfigureElectricityHeatSteam({ i18n });

  return questionBuilder({
    questions: [
      travelVehicles,
      onSitePowerGeneration,
      boilersAndFurnaces,
      buildingOtherFuels,
      onSiteWaterTreatment,
      buildingRefrigerants,
      firefightingExercises,
      electricityHeatSteam,
      evCharging,
      deicing,

      phantomFuelAndEnergy,
      wasteGeneratedInOps,
      businessTravel,
      travelEmployeeCommutes,
    ],
  });
};
